import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Car, Users, BookOpen, MessageSquare, Check, Home as HomeIcon } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Page } from "@/components/shared";

const STATUSES = [
  { id: "heading_home", label: "I'm heading home" },
  { id: "home", label: "I'm home" },
  { id: "with_crew", label: "I'm staying with my crew" },
];

export default function GetHome() {
  const nav = useNavigate();
  const [status, setStatus] = useState(null);
  const [feedback, setFeedback] = useState("");

  const mark = async (s) => {
    setStatus(s.id);
    await api.post("/me/night-status", { status: s.label });
    toast.success(s.label);
  };

  const bookRide = () => {
    toast.success("Opening rideshare… (demo deep-link)");
    window.open("https://m.uber.com/", "_blank");
  };

  return (
    <Page className="px-5 pt-6">
      <button data-testid="gethome-back" onClick={() => nav(-1)} className="cs-tap flex items-center gap-1 text-sm mb-4" style={{ color: "var(--cs-fg2)" }}>
        <ArrowLeft size={18} /> Back
      </button>

      <div className="text-center py-4">
        <span className="grid place-items-center rounded-full mx-auto magenta-grad magenta-glow" style={{ width: 64, height: 64 }}>
          <HomeIcon size={30} className="text-white" />
        </span>
        <h1 className="font-head font-extrabold text-4xl mt-4">END OF NIGHT</h1>
        <p className="mt-2 text-base" style={{ color: "var(--cs-fg2)" }}>Same energy. You made it.</p>
      </div>

      <div className="space-y-3 mt-2">
        <button data-testid="gethome-book-ride" onClick={bookRide}
          className="cs-tap w-full rounded-2xl p-4 flex items-center gap-3" style={{ background: "var(--cs-green)", color: "#000" }}>
          <Car size={24} /> <span className="font-head font-bold text-lg">Book a Safe Ride</span>
        </button>
        <button data-testid="gethome-checkin-crew" onClick={() => nav("/app/crew")}
          className="cs-card cs-tap w-full p-4 flex items-center gap-3">
          <Users size={22} style={{ color: "var(--cs-magenta)" }} /> <span className="font-semibold">Check In With My Crew</span>
        </button>
        <button data-testid="gethome-support" onClick={() => nav("/app/help")}
          className="cs-card cs-tap w-full p-4 flex items-center gap-3">
          <BookOpen size={22} style={{ color: "var(--cs-blue)" }} /> <span className="font-semibold">Access Support Services</span>
        </button>
      </div>

      <div className="cs-card mt-5 p-4">
        <p className="text-xs font-bold tracking-wide mb-3" style={{ color: "var(--cs-fg2)" }}>LET YOUR CREW KNOW</p>
        <div className="space-y-2">
          {STATUSES.map((s) => (
            <button key={s.id} data-testid={`gethome-status-${s.id}`} onClick={() => mark(s)}
              className="cs-tap w-full rounded-xl py-3 px-4 flex items-center justify-between font-semibold text-sm"
              style={{ background: status === s.id ? "rgba(16,185,129,0.15)" : "var(--cs-card-hi)", border: `1px solid ${status === s.id ? "var(--cs-green)" : "var(--cs-border)"}` }}>
              {s.label} {status === s.id && <Check size={18} style={{ color: "var(--cs-green)" }} />}
            </button>
          ))}
        </div>
      </div>

      <div className="cs-card mt-4 p-4">
        <p className="text-xs font-bold tracking-wide mb-2 flex items-center gap-1.5" style={{ color: "var(--cs-fg2)" }}>
          <MessageSquare size={14} /> SHARE FEEDBACK
        </p>
        <textarea data-testid="gethome-feedback" value={feedback} onChange={(e) => setFeedback(e.target.value)} rows={2}
          placeholder="How was your Carnival experience?" className="w-full rounded-xl p-3 outline-none" style={{ background: "var(--cs-card-hi)", border: "1px solid var(--cs-border)", color: "#fff", resize: "none", fontSize: 16 }} />
        <button data-testid="gethome-feedback-submit" onClick={() => { toast.success("Thanks for the feedback!"); setFeedback(""); }}
          className="cs-tap w-full mt-2 rounded-xl py-3 font-semibold text-sm" style={{ background: "var(--cs-card-hi)", border: "1px solid var(--cs-border)" }}>
          Submit feedback
        </button>
      </div>

      <button data-testid="gethome-view-impact" onClick={() => nav("/app/impact")}
        className="cs-tap w-full mt-4 mb-2 text-sm font-semibold" style={{ color: "var(--cs-magenta)" }}>
        See My Impact →
      </button>
    </Page>
  );
}
